import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AuthenticationService} from '../services/authentication.service';
import {SYSTEM_NAME, PRODUCTION_BUILD, DEVAPI_BUILD} from '../app.settings';
import { AppRedirectService } from '../services/app-redirect.service';
import { AppCommunicationService } from '../services/app-communication.service';

@Injectable()
export class AuthGuard implements CanActivate {

    constructor(
        private router: Router,
        private _appCommunicationService: AppCommunicationService,
        private authenticationService: AuthenticationService,
        private appRedirectService: AppRedirectService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let returnUrl = true;

        if (!PRODUCTION_BUILD && !DEVAPI_BUILD) {
            if (route.queryParams
                && route.queryParams.development
                && decodeURIComponent(route.queryParams.development) === 'true') {
                if (route.queryParams.user) {
                    this.authenticationService.saveLoggedUserFromEncrypted(decodeURIComponent(route.queryParams.user));
                }
            }
        } else {
            if (route.url && route.url[0] && route.url[0].path === 'dev') {
                this.router.navigate(['']);
                return false;
            }
        }

        if (this.authenticationService.checkForUserCookie() && !AuthenticationService.isSessionExpired()) {
            this.authenticationService.checkTokenRefreshRequirement();

            if (AuthenticationService.checkSystemAccessPermission()) {
                return true;
            } else {
                returnUrl = false;
            }
        }

        this.appRedirectService.redirectLogin(returnUrl);
        return false;
    }

    hasAccess(): boolean {
        return this._appCommunicationService.getRoleOfLoggedUser() === 1;
    }
}



// WEBPACK FOOTER //
// ./src/app/+app-custom/guards/auth.guard.ts